import { render, staticRenderFns } from "./RentToOwnSettingsCard.vue?vue&type=template&id=bffcaeba"
import script from "./RentToOwnSettingsCard.vue?vue&type=script&lang=js"
export * from "./RentToOwnSettingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports